module.exports = __webpack_public_path__ + "static/media/phone1.9bb73dae.png";